<template>
  <div
    @contextmenu="handleContextMenu"
    @mousedown="isEditMode && handle_vshape_mousedown($event)"
    @click.stop="isEditMode && handleClickChart"
    class="v-shape"
    :class="{ blueboder: realActive }"
    :style="Style"
    v-if="isShowChart"
  >
    <div v-if="realActive === true">
      <div
        class="dot"
        v-for="item in pointList"
        :key="item"
        @mousedown="handleMouseDownOnPoint(item)"
        :style="getPointStyle(item)"
      ></div>
    </div>
    <slot></slot>
    <div class="moveIcon iconfont icon-arrows-alt" v-if="realActive === true"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'VShape',
  props: {
    Configuration: Object,
    ProjectInfo: Object,
    ComboBoxCharts: Object,
    active: Boolean,
  },
  data() {
    return {
      realActive: false,
      isShowChart: true,
      isMoving: false,
      timer_leave_id: null,
      timerId: null,
      debounceTimerId: null,
      debounceTimerId2: null,
      Style: {},
      pointList: ['t', 'r', 'b', 'l', 'lt', 'rt', 'lb', 'rb'],
      cursors: {
        t: 'ns-resize',
        b: 'ns-resize',
        r: 'ew-resize',
        l: 'ew-resize',
        rt: 'nesw-resize',
        lb: 'nesw-resize',
        lt: 'nwse-resize',
        rb: 'nwse-resize',
      },
    };
  },
  created() {
    this.setShowStatus();
    this.debounce_applyConfigPosSize = this.$_.debounce(this.applyConfigPosSize, 300);
    this.debounce_updatePropertyData = this.$_.debounce(this.updatePropertyData, 300);
  },
  mounted() {
    this.getCoponentSizeStyle();
    this.realActive = this.active;
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
  },
  unmounted() {
    this.debounce_applyConfigPosSize.cancel();
    this.debounce_updatePropertyData.cancel();
  },
  watch: {
    active(newVal) {
      console.log('--------------------点击组件');

      if (this.$store.state.isEditMode === true) {
        this.realActive = newVal;
      }
    },
    ProjectInfo: {
      deep: true,
      handler: function () {
        this.getCoponentSizeStyle();
      },
    },
    Configuration: {
      deep: true,
      handler: function () {
        this.setShowStatus();
        this.getCoponentSizeStyle();
        this.debounce_applyConfigPosSize();
        this.debounce_updatePropertyData();
      },
    },
    ComboBoxCharts: {
      deep: true,
      handler: function () {
        this.setShowStatus();
        this.getCoponentSizeStyle();
        this.debounce_applyConfigPosSize();
        this.debounce_updatePropertyData();
      },
    },
  },
  methods: {
    applyConfigPosSize() {
      if (
        this.Configuration &&
        this.Configuration.propertyData &&
        this.Configuration.propertyData.posSize &&
        this.isMoving === false &&
        this.$store.state.isEdingChartsPosSize
      ) {
        console.log('应用 posSize');
        if (this.$store.state.CurrentConfigration.style) {
          this.$store.commit('update_CurrentConfigration', {
            style: { ...this.Configuration.propertyData.posSize.value },
          });
        }
      }
    },
    updatePropertyData() {
      this.$store.commit('update_PropertyData', {
        key: 'posSize',
        value: { ...this.Configuration.style },
      });
      console.log('gengxin');
    },
    handleContextMenu(e) {
      if (!this.isEditMode) return;
      e.stopPropagation();
      e.returnValue = false;
      // let TimerId = null;
      let top = e.clientY;
      let left = e.clientX;
      this.$store.commit('set_ContextMenu', {
        isOpen: true,
        position: {
          left,
          top,
        },
      });
      const up = () => {
        document.removeEventListener('mousedown', up);
        // this.$store.commit('set_ContextMenu', {
        //   isOpen: true,
        //   position: {
        //     left,
        //     top,
        //   },
        // });
      };
      document.addEventListener('mousedown', up);
    },
    deleteChart() {
      this.$store.commit('del_Charts', this.Configuration.id);
    },
    handleClickChart() {
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    setShowStatus() {
      this.isShowChart = this.Configuration.propertyData.showStatus.value === 'norm';
    },
    getCoponentSizeStyle() {
      // console.log(this.Configuration, 'Configuration Configuration');
      let { width, height, left, top } = this.Configuration.style;

      this.Style.width = width + 'px';
      this.Style.height = height + 'px';
      this.Style.top = top + 'px';
      this.Style.left = left + 'px';

      if (this.Configuration.propertyData.chartsOpicity) {
        this.Style.opacity = this.Configuration.propertyData.chartsOpicity.value;
      }
      if (this.Configuration.propertyData.chartsColor) {
        this.Style.backgroundColor = this.Configuration.propertyData.chartsColor.value.chartBackgroundColor;
      }
      if (this.Configuration.componentName === 'Others10Charts') {
        let CombStyle = this.Configuration.propertyData.posSize;
        let CombPosSize = this.Configuration.style;
        // console.log(CombStyle, CombPosSize, 'CombStyle CombPosSize');
      }
      // 判断不等于风格8时加背景色
      // if (this.ProjectInfo.Style.componentName != "V8Style") {
      //   this.Style.backgroundColor = `background:transparent  !important`
      // }
    },
    getPointStyle(point) {
      const { width, height } = this.Configuration.style;
      const hasT = /t/.test(point);
      const hasB = /b/.test(point);
      const hasL = /l/.test(point);
      const hasR = /r/.test(point);
      let newLeft = 0;
      let newTop = 0;
      // 四个角的点
      if (point.length === 2) {
        newLeft = hasL ? 0 : width;
        newTop = hasT ? 0 : height;
      } else {
        // 上下两点的点，宽度居中
        if (hasT || hasB) {
          newLeft = width / 2;
          newTop = hasT ? 0 : height;
        }
        // 左右两边的点，高度居中
        if (hasL || hasR) {
          newLeft = hasL ? 0 : width;
          newTop = Math.floor(height / 2);
        }
      }

      const style = {
        marginLeft: hasR ? '-4px' : '-2px',
        marginTop: '-4px',
        left: `${newLeft - 2}px`,
        top: `${newTop - 2}px`,
        cursor: this.cursors[point],
      };
      return style;
    },
    handleMouseDownOnPoint(point) {
      console.log(point, 'set_CurrentConfigration');
      this.isMoving = true;
      this.$store.commit('set_CurrentConfigration', this.Configuration);
      const downEvent = window.event;
      downEvent.stopPropagation();
      this.$store.commit('update_CurrentConfigration', {
        isScaling: true,
      });
      const pos = { ...this.Configuration.style };
      const height = Number(pos.height);
      const width = Number(pos.width);
      const top = Number(pos.top);
      const left = Number(pos.left);
      const startX = downEvent.clientX;
      const startY = downEvent.clientY;
      const move = moveEvent => {
        const currX = moveEvent.clientX;
        const currY = moveEvent.clientY;
        const disY = currY - startY;
        const disX = currX - startX;
        const hasT = /t/.test(point);
        const hasB = /b/.test(point);
        const hasL = /l/.test(point);
        const hasR = /r/.test(point);
        const newHeight = height + (hasT ? -disY : hasB ? disY : 0);
        const newWidth = width + (hasL ? -disX : hasR ? disX : 0);
        pos.height = newHeight > 0 ? newHeight : 0;
        pos.width = newWidth > 0 ? newWidth : 0;
        pos.left = left + (hasL ? disX : 0);
        pos.top = top + (hasT ? disY : 0);
        this.$store.commit('update_CurrentConfigration', {
          style: { ...pos },
        });
      };
      const up = () => {
        this.isMoving = false;
        this.$store.commit('update_CurrentConfigration', {
          isScaling: false,
        });
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
    handle_vshape_mousedown(e) {
      // e.stopPropagation();
      console.log(e, 'eeeee');
      if (e.which !== 3) {
        console.log('handle_vshape_mousedown', e);
        this.$store.commit('set_ContextMenu', {
          isOpen: false,
        });
      }

      this.isMoving = true;
      this.$store.commit('set_CurrentConfigration', this.Configuration);
      this.$store.commit('update_CurrentConfigration', {
        isMoving: true,
      });
      const startY = e.clientY;
      const startX = e.clientX;
      const startTop = this.Configuration.style.top;
      const startLeft = this.Configuration.style.left;
      let move = moveEvent => {
        const currX = moveEvent.clientX;
        const currY = moveEvent.clientY;
        let pos = {
          top: currY - startY + startTop,
          left: currX - startX + startLeft,
          width: parseInt(this.Style.width),
          height: parseInt(this.Style.height),
        };
        this.$store.commit('update_CurrentConfigration', {
          style: { ...pos },
        });
      };
      const up = () => {
        this.isMoving = false;
        this.$store.commit('update_CurrentConfigration', {
          isMoving: false,
        });
        document.removeEventListener('mousemove', move);
        document.removeEventListener('mouseup', up);
      };
      document.addEventListener('mousemove', move);
      document.addEventListener('mouseup', up);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: 'iconfont'; /* Project id 2621718 */
  src: url('//at.alicdn.com/t/font_2621718_a00rg8rx7cr.woff2?t=1624185456712') format('woff2'),
    url('//at.alicdn.com/t/font_2621718_a00rg8rx7cr.woff?t=1624185456712') format('woff'),
    url('//at.alicdn.com/t/font_2621718_a00rg8rx7cr.ttf?t=1624185456712') format('truetype');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-arrows-alt:before {
  content: '\e833';
}

.v-shape {
  position: absolute;
  box-sizing: border-box;
  z-index: 99;
  border: 1px solid rgba(0, 0, 0, 0);

  .moveIcon {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: move;
    position: absolute;
    bottom: -30px;
    z-index: 1;
    left: 50%;
    font-size: 20px;
    transform: translateX(-46%);
    color: #008cff;
  }
}
.right_mouse_menu {
  width: 100px;
  height: 100px;
  position: fixed;
  left: 0;
  top: 0;
  display: none;
  background-color: burlywood;
}
.blueboder {
  border: 1px solid #008cff;
}
.dot {
  position: absolute;
  width: 8px;
  height: 8px;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: rgb(255, 255, 255);
  overflow: hidden;
  border: 1px solid rgb(0, 162, 255);
  // z-index: 2;
}
</style>
